document.addEventListener('DOMContentLoaded', function() {
  // Initialize after a short delay to ensure DOM is fully loaded
  setTimeout(initPriceSliders, 300);

  // Re-initialize when facet drawers are opened
  document.addEventListener('click', function(e) {
    if (e.target && (e.target.classList.contains('mobile-facets__open') || 
        e.target.closest('.mobile-facets__open'))) {
      setTimeout(initPriceSliders, 500);
    }
  });

  // Set up the observer to watch for changes in the parent element
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        // Check if our target element was added
        const priceSlider = document.getElementById('price-slider');
        if (priceSlider) {
          // Element found, run your code
          initPriceSliders();
        }
      }
    }
  });
  
  // Start observing the document or a specific parent element
  observer.observe(document.body, { childList: true, subtree: true });
});

function initPriceSliders() {
  // Find all price range containers that don't have sliders yet. Two components, one for mobile and one for desktop
  const priceRanges = document.querySelectorAll('price-range:not([data-slider-initialized])');

  priceRanges.forEach(function(container) {
    const minInput = container.querySelector('input[id*="-GTE"]');
    const maxInput = container.querySelector('input[id*="-LTE"]');

    if (!minInput || !maxInput) return;

    // Create slider container
    const sliderContainer = container.querySelector('div.price-slider')

    // Get min/max and current values
    const min = parseInt(minInput.getAttribute('min') || 0);
    const max = parseInt(maxInput.getAttribute('max') || 1000);
    const currentMin = minInput.value ? parseInt(minInput.value) : min;
    const currentMax = maxInput.value ? parseInt(maxInput.value) : max;

    // Initialize noUiSlider
    noUiSlider.create(sliderContainer, {
      start: [currentMin, currentMax],
      connect: true,
      step: 1,
      range: {
        'min': min,
        'max': max
      }
    });

    // Update input values when slider changes
    sliderContainer.noUiSlider.on('update', function(values, handle) {
      const value = parseInt(values[handle]);
      if (handle === 0) {
        minInput.value = value;
      } else {
        maxInput.value = value;
      }
    });

    // Trigger native input events so Dawn picks up changes
    sliderContainer.noUiSlider.on('change', function(values) {
      const [minValue, maxValue] = values.map(v => parseInt(v));
      minInput.value = minValue;
      maxInput.value = maxValue;
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Mark as initialized
    container.setAttribute('data-slider-initialized', 'true');

    // Update slider when inputs change directly
    minInput.addEventListener('change', function() {
      sliderContainer.noUiSlider.set([this.value, null]);
    });

    maxInput.addEventListener('change', function() {
      sliderContainer.noUiSlider.set([null, this.value]);
    });
  });
}
